import { createContext } from "react";

const LedgerContext = createContext();

export default LedgerContext;
